// Copyright (C) 2021 TANNER AG

import React from "react";
import { compose } from "recompose";
import withConnectionStatus from "../hocs/withConnectionStatus";
import withGeneralTranslations from "../hocs/withGeneralTranslations";
import withLocalization from "../hocs/withLocalization";
import withErrorState from "../hocs/withErrorState";
import { withStyles } from "@material-ui/core/styles";
import { sharedComponentStyles } from "../screens/Component";
import withEMobilityTopics from "../hocs/withEMobilityTopics";
import { pad } from "../utils/helper";
import EMobilityTocTopic from "./EMobilityTocTopic";
import EMobilityTocChapter from "./EMobilityTocChapter";
import { NAVIGATION_HEIGHT } from "../layouts/Navigation";
import { HEADER_HEIGHT } from "../layouts/Header";
import Heading6 from "../styleguide/Heading6";
import routes from "./routes";

const styles = (theme) => ({
    root: {
        position: "sticky",
        top: HEADER_HEIGHT + NAVIGATION_HEIGHT,
        padding: "16px 0 8px 32px",
    },
    heading: {
        marginBottom: 16,
    },
});

const EMobilityToc = ({ classes, eMobilityTopics, chapter }) => {
    return (
        <div className={classes.root}>
            <Heading6 className={classes.heading}>E-MOBILITY KNOWLEDGE</Heading6>
            {eMobilityTopics &&
                eMobilityTopics
                    .filter((currentTopic) => currentTopic.active)
                    .map((currentTopic) => (
                        <EMobilityTocTopic
                            key={currentTopic.id}
                            title={currentTopic.title}
                            number={pad(currentTopic.order, 2)}
                            open={chapter.eMobilityTopic.order === currentTopic.order}
                            to={`${routes.eMobility}/${currentTopic.slug}`}
                        >
                            {currentTopic.eMobilityChapters &&
                                currentTopic.eMobilityChapters.map((currentChapter) => (
                                    <EMobilityTocChapter
                                        key={currentChapter.id}
                                        number={`${currentTopic.order}.${currentChapter.order}`}
                                        title={currentChapter.title}
                                        selected={chapter.order === currentChapter.order}
                                        to={`${routes.eMobility}/${currentTopic.slug}/${currentChapter.slug}`}
                                    />
                                ))}
                        </EMobilityTocTopic>
                    ))}
        </div>
    );
};

export default compose(
    withConnectionStatus,
    withGeneralTranslations,
    withLocalization,
    withErrorState,
    withStyles(sharedComponentStyles),
    withStyles(styles),
    withEMobilityTopics()
)(EMobilityToc);



// WEBPACK FOOTER //
// ./src/emobility/EMobilityToc.js